import {loadStateFromLocalStorage, restoreState} from "./localStorage";

export const CALCULATOR_TO_LEAD = 'CALCULATOR_TO_LEAD'
export const calculatorToLead = (payload) => ({type: CALCULATOR_TO_LEAD, payload});

export const restoreStateIfNessesary = () => {
  return (dispatch, getState) => {
      let state = getState();

      if(state.lead && state.lead.calculator && state.lead.calculator.calculatorId) {

      } else {
        let storedState = loadStateFromLocalStorage();
        if(storedState) {
          dispatch(restoreState(storedState));
        }
      }
  };
};


// WEBPACK FOOTER //
// ./src/actions/lead.js